import { apiFetch } from "./apiClient";

export async function getDocumentsByDeviceId(deviceId) {
  const res = await apiFetch(`/api/services/service/all-documents/${deviceId}`);
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || "Failed to fetch documents");
  }
  const data = await res.json();
  return { success: true, data };
}

export async function updateDocument(documentData) {
  const res = await apiFetch(`/api/services/service/update-document`, {
    method: "PUT",
    body: JSON.stringify({ documentData }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to update document",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function createDocument(documentData) {
  const res = await apiFetch(`/api/services/service/create-document`, {
    method: "POST",
    body: JSON.stringify({ documentData }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to create document",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function deleteDocument(documentId) {
  const res = await apiFetch(`/api/services/service/delete-document`, {
    method: "DELETE",
    body: JSON.stringify({ documentId }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to delete document",
    };
  }
  const data = await res.json();
  return { success: true, data };
}
